import common from './common'
import layout from './layout'
import views from './views'
import tools from './tools'

export default {
  common,
  layout,
  view: views,
  tool: tools
}
